module.exports = __webpack_public_path__ + "SourceSansPro-Black.e6d1684daf0ab3fad55b.woff";


//////////////////
// WEBPACK FOOTER
// C:/Users/jerd_/Documents/e-payment-public/e-payment-frontend/src/assets/customfonts/SourceSansPro-Black.woff
// module id = ../../../../../src/assets/customfonts/SourceSansPro-Black.woff
// module chunks = styles